




















import CartViewItem from '@spa/components/organisms/cart/Item.vue'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { formatPrice } from '@/util/format'

import { CartItem } from '@spa/store/modules/cart/types'

@Component({
  components: {
    CartViewItem,
  },
})
export default class OrderItem extends Vue {
  @Prop({ required: true })
  cartItems: CartItem[]

  formatPrice(price: number): string {
    return formatPrice(price)
  }
}
